<template>
  <div class="nav-wrap">
    <div class="item" v-for="(item, index) in navs" :key="index">
      <a>
        <div v-if="haveActive" @click="change(item, index)" :class="{active: activeTab === index}">{{item.label ?
          item.label : item}}
        </div>
        <div v-else @click="change(item, index)" :class="{active: currentTab === index}">{{item.label ? item.label :
          item}}
        </div>
      </a>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      navs: {
        type: Array
      },
      currentTab: {
        default: 0
      },
      haveActive: {
        default: true
      }
    },
    data () {
      return {
        activeTab: 0
      }
    },
    watch: {
      currentTab () {
        this.activeTab = this.currentTab
      }
    },
    created () {
      this.activeTab = this.currentTab
      if (this.currentTab === -1) {
        this.activeTab = 0
      }
    },
    methods: {
      change (item, index) {
        this.activeTab = index
        if (item.value) {
          item.index = index
          this.$emit('change', item.value, item)
        } else {
          this.$emit('change', item, index)
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>

  .nav-wrap {
    display flex
    align-items center
    .item {
      /*background-color: #E91D1D;*/
      margin-right: 20px;
      height: 30px;
      line-height: 30px;
      a div:hover {
        color: #2074d0;
      }
      .active {
        color: #2074d0;
        border-bottom: 3px solid #2074d0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Nav.vue?69cc059f